export default {
    methods:{
        labStatusColor(status){
            status =  status.replace(/^\s+|\s+$/gm,'');
            status =  status.toUpperCase()
            if ( status === "RESULT" ) {
                return  `is-success`
            }else if (status === "REJECT" ){
                return `is-danger`
            }else if (status === "CANCEL" ){
                return `is-danger`
            }else if (status === "REQUEST"){
                return `is-warning`  //"is-light"
            }else if (status === "ACCEPT") {
                return `is-dark`
            }

        }
    }

}